import { COLUMN_FILTER_CONFIG, type ColumnFilterParamConfig } from './columns';

export interface ColumnFilterLike {
  id: string;
  value: unknown;
}

const toArray = (raw: unknown): string[] => {
  if (raw === null || raw === undefined) return [];
  if (Array.isArray(raw)) {
    return raw.map((value) => (value == null ? '' : String(value))).map((value) => value);
  }
  return [String(raw)];
};

const encodeListFilter = (
  config: Extract<ColumnFilterParamConfig, { type: 'list' }>,
  raw: unknown,
) => {
  let values = toArray(raw).map((value) => value.trim());
  if (!values.length) return undefined;
  if (config.normalize) values = config.normalize(values);
  values = values.filter((value) => value !== undefined && value !== null);
  if (!values.length) return undefined;
  return values.join(',');
};

const encodeTextFilter = (
  config: Extract<ColumnFilterParamConfig, { type: 'text' }>,
  raw: unknown,
) => {
  const valueLike = Array.isArray(raw) ? raw[0] : raw;
  if (valueLike === null || valueLike === undefined) return undefined;
  let value = String(valueLike);
  value = config.normalize ? config.normalize(value) : value.trim();
  if (!value) return undefined;
  return value;
};

export function buildColumnFilterQuery(filters: ColumnFilterLike[]): Map<string, string> {
  const params = new Map<string, string>();
  for (const filter of filters) {
    const config = COLUMN_FILTER_CONFIG[filter.id];
    if (!config) continue;
    const value =
      config.type === 'list'
        ? encodeListFilter(config, filter.value)
        : encodeTextFilter(config, filter.value);
    if (value !== undefined) {
      params.set(config.param, value);
    }
  }
  return params;
}

export function applyColumnFiltersToParams(
  params: URLSearchParams,
  filters: ColumnFilterLike[],
): URLSearchParams {
  const entries = buildColumnFilterQuery(filters);
  for (const [key, value] of entries) {
    params.set(key, value);
  }
  return params;
}
